module.exports = __webpack_public_path__ + "img/hide-english-three.1c471e2d.png";